import {
  AddressDTO,
} from '@/dtos/addressDTO';
import pick from 'lodash/pick';
import values from 'lodash/values';
import {
  isEmptyString,
  notEmptyString,
} from 'utils/misc';

type AddressFields = Pick<AddressDTO, 'street' | 'unit' | 'city' | 'state' | 'zipCode'>;

export const addressFields = Object.freeze(['street', 'unit', 'state', 'zipCode', 'city']);
export const requiredAddressFields = Object.freeze(new Set(['street', 'state', 'zipCode', 'city']));

export const addressRequiredFieldsNotEmpty = (
  address: AddressFields,
) => values(pick(address, Array.from(requiredAddressFields))).every(notEmptyString);

export const validateAddress = (
  address: AddressFields,
) => (
  values(pick(address, addressFields)).every(isEmptyString)
    || values(pick(address, Array.from(requiredAddressFields))).every(notEmptyString)
);

export const validateZipCode = (value: string | null | undefined) => (
  isEmptyString(value) ? true : /^\d{5}(-\d{4})?$/.test(value ?? '')
);
export const validateLongZipCode = (value: string | null | undefined) => (
  isEmptyString(value) ? true : /^\d{5}-\d{4}$/.test(value ?? '')
);

export const validateAddressInfo = (
  value?: Pick<AddressDTO, 'street' | 'unit' | 'city' | 'state' | 'zipCode'>,
) => validateAddress(value ?? {}) && validateZipCode(value?.zipCode);

export const validateAddressWithLongZipCode = (
  address: AddressFields,
) => (addressRequiredFieldsNotEmpty(address) && validateLongZipCode(address?.zipCode));
